<template>
  <div>
    <el-row class="integration-available-grid">
      <el-col :span="4">
        <FreteRapidoComponent ref="freteRapido" />
      </el-col>
      <el-col :span="4">
        <IntelipostComponent ref="intelipost" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import FreteRapidoComponent from './webhooks/FreteRapidoComponent.vue';
import IntelipostComponent from './webhooks/IntelipostComponent.vue';

export default {
  name: "CustomerWebhooks",
  components: { FreteRapidoComponent, IntelipostComponent },
  methods: {
    setup(data) {
      this.$refs.freteRapido.setup(data)
      this.$refs.intelipost.setup(data)
    },
    get() {
      return {
        freterapido: this.$refs.freteRapido.get(),
        intelipost: this.$refs.intelipost.get(),
      }
    },
    validate() {
      return true;  
    },
  },
};
</script>
<style>
.integration-available-grid {
  display: flex;
  flex-wrap: wrap;
}

.integration-available-grid .el-col {
  float: none;
  display: flex;
  margin-bottom: 16px;
  margin: 4px;
}

.integration-available-grid .el-col > div {
  width: 100%;
}
</style>

